import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react'
import {Pie, Bar} from 'react-chartjs-2';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import LocalDate from '../LocalDate'
import ShowLocalNumber from '../ShowLocalNumber'
import MovimentoEntrUsc from '../movimenti/MovimentoEntrUsc'
import {getChartColors} from '../../Helpers'

class ReportCommesseCostidiretti extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entrate:[],
            entratePdc2Liv:[],
            entratePdc1Liv:[],
            entratePieData: {},
            entrateBarData: {},
            uscite:[],
            uscitePdc2Liv:[],
            uscitePdc1Liv:[],
            uscitePieData: {},
            usciteBarData: {},
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
        this.loadData(this.props.commessa.idCommessa, this.props.dataStart, this.props.dataEnd);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.commessa !== this.props.commessa || nextProps.dataStart !== this.props.dataStart || nextProps.dataEnd !== this.props.dataEnd)
        {
            this.loadData(nextProps.commessa.idCommessa, nextProps.dataStart, nextProps.dataEnd);
        }
    }

    loadData(idCommessa, dataStart, dataEnd) {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportCommesseCostidiretti(idCommessa, dataStart, dataEnd).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({                        
                        entrate: data.entrate,
                        entratePdc2Liv: data.entratePdc2Liv,
                        entratePdc1Liv: data.entratePdc1Liv,
                        entratePieData: this.createPieData(data.entratePdc1Liv),
                        entrateBarData: this.createBarData(data.entratePdc2Liv, 'Totali entrate per PDC (voce e sottovoce)', 8),
                        uscite: data.uscite,
                        uscitePdc2Liv: data.uscitePdc2Liv,
                        uscitePdc1Liv: data.uscitePdc1Liv,
                        uscitePieData: this.createPieData(data.uscitePdc1Liv),
                        usciteBarData: this.createBarData(data.uscitePdc2Liv, 'Totali uscite per PDC (voce e sottovoce)', 9),
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    createPieData(items)
    {
        let labels = [];
        let datas = [];
        for(let i=0; i<items.length; i++){

            labels.push(items[i].liv1);
            datas.push(items[i].corrispettivo);
        }

        const data = {
            labels: labels,
            datasets: [{
                data: datas,
                backgroundColor: getChartColors(),
                hoverBackgroundColor: getChartColors(),
            }]
        };
        return data;
    }

    createBarData(items, titolo, colore)
    {
        let labels = [];
        let datas = [];
        for(let i=0; i<items.length; i++){

            labels.push(items[i].liv1 + "/" + items[i].liv2);
            datas.push(items[i].pagamento);
        }

        const data = {
            labels: labels,
            datasets: [{
                label: titolo,
                data: datas,
                borderWidth: 1,
                backgroundColor: getChartColors(1)[colore],
                hoverBackgroundColor: getChartColors(1)[colore],
            }]
        };
        return data;
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        const entrateBarData = this.props.viewCharts ? <Bar data={this.state.entrateBarData} options={{legend: {position: 'bottom'}}}/> : null
        const entratePieData = this.props.viewCharts ? <Pie data={this.state.entratePieData} options={{legend: {position: 'bottom'}}}/> : null
        const usciteBarData = this.props.viewCharts ? <Bar data={this.state.usciteBarData} options={{legend: {position: 'bottom'}}}/> : null
        const uscitePieData = this.props.viewCharts ? <Pie data={this.state.uscitePieData} options={{legend: {position: 'bottom'}}}/> : null

        return (<div className="ui grid">
            {/*Qui ci vanno le entrate*/}
            <div className="sixteen wide column">

                {this.renderMovimenti(this.state.entrate, 'E', 'Entrate', 'green')}

            </div>
            <div className="eight wide column">
                {this.renderMovimentiPdc2Liv(this.state.entratePdc2Liv, 'E', 'Totali entrate per PDC (voce e sottovoce)', 'green')}
                {entrateBarData}
            </div>
            <div className="eight wide column">
                {this.renderMovimentiPdc1Liv(this.state.entratePdc1Liv, 'E', 'Totali entrate per PDC (voce principale)', 'green')}
                {entratePieData}
            </div>
            {/*Qui ci vanno le uscite*/}
            <div className="sixteen wide column">
                {this.renderMovimenti(this.state.uscite, 'U', 'Uscite', 'red')}
            </div>
            <div className="eight wide column">
                {this.renderMovimentiPdc2Liv(this.state.uscitePdc2Liv, 'U', 'Totali uscite per PDC (voce e sottovoce)', 'red')}
                {usciteBarData}
            </div>
            <div className="eight wide column">
                {this.renderMovimentiPdc1Liv(this.state.uscitePdc2Liv, 'U', 'Totali uscite per PDC (voce principale)', 'red')}
                {uscitePieData}
            </div>
            {loader}
        </div>)
    }


    renderMovimenti(items, tipo, titolo, colore){
        let i=0;
        let sommaCorrispettivo = 0;
        let sommaPagamento = 0;
        return (
            <Table celled color={colore}>
                {/*<Table.Header>*/}
                {/*    <Table.Row>*/}
                {/*        <Table.HeaderCell colSpan={8}>*/}
                {/*            <MovimentoEntrUsc tipo={tipo}/> {titolo}*/}
                {/*        </Table.HeaderCell>*/}
                {/*    </Table.Row>*/}
                {/*    <Table.Row>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            ID*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Data (Anno comp.)*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell  textAlign='center'>*/}
                {/*            P/D*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            PDC*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Soggetto*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell textAlign='center'>*/}
                {/*            E/C*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Causale*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Forma*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Corrispettivo*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Pagamento*/}
                {/*        </Table.HeaderCell>*/}
                {/*    </Table.Row>*/}
                {/*</Table.Header>*/}
                <Table.Body>
                    <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                        <Table.Cell colSpan={8}>
                            <MovimentoEntrUsc tipo={tipo}/> {titolo}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row style={{fontWeight: 'bold'}}>
                        <Table.Cell>
                            ID
                        </Table.Cell>
                        <Table.Cell>
                            Data (Anno comp.)
                        </Table.Cell>
                        <Table.Cell  textAlign='center'>
                            P/D
                        </Table.Cell>
                        <Table.Cell>
                            PDC
                        </Table.Cell>
                        <Table.Cell>
                            Soggetto
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            E/C
                        </Table.Cell>
                        <Table.Cell>
                            Causale
                        </Table.Cell>
                        <Table.Cell>
                            Forma
                        </Table.Cell>
                        <Table.Cell>
                            Corrispettivo
                        </Table.Cell>
                        <Table.Cell>
                            Pagamento
                        </Table.Cell>
                    </Table.Row>
                    {
                        items.map((item) => {
                            sommaCorrispettivo += Number.parseFloat(item.corrispettivo);
                            sommaPagamento += Number.parseFloat(item.pagamento);
                            return <Table.Row key={i++}>
                                <Table.Cell>{item.idMovimento}</Table.Cell>
                                <Table.Cell><LocalDate data={item.data}/></Table.Cell>
                                <Table.Cell textAlign='center'>{item.prevDef}</Table.Cell>
                                <Table.Cell>{item.idPdc.nomeCompleto}</Table.Cell>
                                <Table.Cell>{item.soggetto}</Table.Cell>
                                <Table.Cell  textAlign='center'>{item.estrConto}</Table.Cell>
                                <Table.Cell>{item.causale}</Table.Cell>
                                <Table.Cell>{item.forma}</Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.corrispettivo}/></Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.pagamento}/></Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan={8}  textAlign="right">Totali</Table.HeaderCell>
                        <Table.HeaderCell  textAlign='right'><b><ShowLocalNumber value={sommaCorrispettivo}/></b></Table.HeaderCell>
                        <Table.HeaderCell  textAlign='right'><b><ShowLocalNumber value={sommaPagamento}/></b></Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        )
    }

    renderMovimentiPdc2Liv(items, tipo, titolo, colore){
        let i=0;
        return (
            <Table celled color={colore}>
                {/*<Table.Header>*/}
                {/*    <Table.Row>*/}
                {/*        <Table.HeaderCell colSpan={4}>*/}
                {/*            <MovimentoEntrUsc tipo={tipo}/> {titolo}*/}
                {/*        </Table.HeaderCell>*/}
                {/*    </Table.Row>*/}
                {/*    <Table.Row>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Voce*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Sottovoce*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Corrispettivo*/}
                {/*        </Table.HeaderCell>*/}
                {/*        <Table.HeaderCell>*/}
                {/*            Pagamento*/}
                {/*        </Table.HeaderCell>*/}
                {/*    </Table.Row>*/}
                {/*</Table.Header>*/}
                <Table.Body>
                    <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                        <Table.Cell colSpan={4}>
                            <MovimentoEntrUsc tipo={tipo}/> {titolo}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row style={{fontWeight: 'bold'}}>
                        <Table.Cell>
                            Voce
                        </Table.Cell>
                        <Table.Cell>
                            Sottovoce
                        </Table.Cell>
                        <Table.Cell>
                            Corrispettivo
                        </Table.Cell>
                        <Table.Cell>
                            Pagamento
                        </Table.Cell>
                    </Table.Row>
                    {
                        items.map((item) => {
                            return <Table.Row key={i++}>
                                <Table.Cell>{item.liv1}</Table.Cell>
                                <Table.Cell>{item.liv2}</Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.corrispettivo}/></Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.pagamento}/></Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
            </Table>
        )
    }
    renderMovimentiPdc1Liv(items, tipo, titolo, colore){
        let i=0;
        return (
            <Table celled color={colore}>
                <Table.Header>
                    <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                        <Table.HeaderCell colSpan={4}>
                            <MovimentoEntrUsc tipo={tipo}/> {titolo}
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell>
                            Voce
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Corrispettivo
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Pagamento
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        items.map((item) => {
                            return <Table.Row key={i++}>
                                <Table.Cell>{item.liv1}</Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.corrispettivo}/></Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.pagamento}/></Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
            </Table>
        )
    }
}

ReportCommesseCostidiretti.PropTypes = {
    commessa: PropTypes.object.isRequired,
    viewCharts: PropTypes.bool.isRequired,
    dataStart: PropTypes.string.isRequired,
    dataEnd: PropTypes.string.isRequired,
}

ReportCommesseCostidiretti.defaultProps = {
    viewCharts: false,
};


export default ReportCommesseCostidiretti;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesseCostidiretti.js
 **/